import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text, Loader } from '@stashinvest/ui';
import { v1_ExternalAccountLinkProcessing_Viewed } from '@stashinvest/product-events-javascript/lib/v1/event_static_methods';
import { v1_ExternalAccountLinkProcessing_ViewedProperties } from '@stashinvest/product-events-javascript/lib/v1/properties';
import { Origin } from '@stashinvest/product-events-javascript/lib/enum_properties';

const LinkPlaidLoading = ({ text, trackEvent, isOnboarding }) => {
	useEffect(() => {
		if (!trackEvent) return;
		trackEvent(
			v1_ExternalAccountLinkProcessing_Viewed({
				origin: isOnboarding ? Origin.onboarding : null,
				external_account_type:
					v1_ExternalAccountLinkProcessing_ViewedProperties.ExternalAccountType.bank,
				external_account_connection_type:
					v1_ExternalAccountLinkProcessing_ViewedProperties.ExternalAccountConnectionType
						.instant,
			})
		);
	}, [trackEvent, isOnboarding]);
	return (
		<>
			<Text.H3 mb="m" align="center">
				{text}
			</Text.H3>
			<Loader center />
		</>
	);
};

LinkPlaidLoading.defaultProps = {
	text: 'Loading...',
};

LinkPlaidLoading.propTypes = {
	text: PropTypes.string,
	trackEvent: PropTypes.func,
	isOnboarding: PropTypes.bool,
};

export default LinkPlaidLoading;
